import React from 'react';
import styled from 'styled-components';
import { paths } from '../consts';
import { RouterButton } from '../pages/GISOverView';

type GisFeesProps = {
  className?: string;
};

const Col = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const H1 = styled.h1`
  margin: 0 0 14px;
  font-size: 44px;
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: -0.02em;

  @media (max-width: 767px) {
    font-size: 34px;
  }
`;

const P = styled.p`
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
  color: rgba(11, 18, 32, 0.86);
`;

const Strong = styled.strong`
  font-weight: 800;
`;

const Buttons = styled.div`
  margin: 12px 0 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const Figure = styled.figure`
  margin: 10px 0 18px;
`;

const FeesImage = styled.img`
  width: 100%;
  max-width: 900px;
  height: auto;

  display: block;
  margin: 0 auto;

  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);

  box-shadow:
    0 14px 32px rgba(0, 0, 0, 0.06),
    0 2px 10px rgba(0, 0, 0, 0.04);
`;

const Spacer = styled.div`
  height: 6px;
`;

const Note = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(11, 18, 32, 0.72);

  strong {
    font-weight: 900;
  }
`;

export const GisFees: React.FC<GisFeesProps> = ({ className }) => (
        <Col className={className}>
            <H1>GIS Fees</H1>

            <P>
                Your project’s Guarantee and Inspection Service (“GIS”) fee is based on the architectural
                woodwork contract amount, and the GIS cost is part of the tendered lump sum.
            </P>

            <Buttons>
                <RouterButton to={`${paths.GIS}/${paths.GIS_ESTIMATOR}`}>
                    GIS Fee Estimator
                </RouterButton>
            </Buttons>
            <P>
                <Strong>GIS fees as of January 1, 2023</Strong>
            </P>
            <Figure>
                <FeesImage
                    src="https://awmac.com/wp-content/uploads/2024/11/GIS-Fees.png"
                    alt="GIS fees as of January 1, 2023"
                    loading="lazy"
                    decoding="async"
                />
            </Figure>

            <Spacer aria-hidden="true" />

            <Note>
                <em>
                    1 – <strong>CONTRACT VALUE </strong>refers to the project’s GIS-specified architectural
                    woodwork value.
                </em>
            </Note>

            <Note>
                <em>
                    2 – <strong>GIS FEE </strong>refers to the fee AWMAC charges to the manufacturer, who
                    receives the GIS (and 2-year warranty if an AWMAC Manufacturer member) on a project’s
                    GIS-specified woodwork. Prices may be flat or percentage-based.
                </em>
            </Note>
        </Col>
);
